export const CHECKOUT_URL = 'https://pathway.impultienda.ar/checkout/glp-en'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/e6VMEbunp8bZfL8szZck9K/FERTILIDAD-3.png'

export const BONUS_1_IMAGE =
  'https://cdn.magicpatterns.com/uploads/wJTyMco6FLkKojf9sXaYUH/BONO_1_GLP-EN.png'

export const BONUS_2_IMAGE =
  'https://cdn.magicpatterns.com/uploads/dUR6ZAwHJQVRB84Fbmbjtf/BONO_2_GPL-EN.png'

export const BONUS_3_IMAGE =
  'https://cdn.magicpatterns.com/uploads/684WrB2hBxBTrT6RqXy3DK/BONO_3_GPL-EN.png'

export const BONUS_4_IMAGE =
  'https://cdn.magicpatterns.com/uploads/wNW6tMUEEJQEdDoxo6gF51/BONO_4_GLP-EN.png'

export const BONUS_5_IMAGE =
  'https://cdn.magicpatterns.com/uploads/nTiU7ZB6BErwksyReCFYvJ/BONO_5_GPL-EN.png'

export const KARITO_PHOTO =
  'https://cdn.magicpatterns.com/patterns/generated-images/ccf6509e-cf04-4fb4-8798-879c28694d0b.jpg'

export const stats = [
  { value: '+300', label: 'Clinical protocols ready to use' },
  { value: '+1,200', label: 'Satisfied physicians' },
  { value: '2,400+', label: 'Hours of study condensed' },
  { value: '98%', label: 'Would recommend it' },
]

export const beforeItems = [
  'Every patient creates new doubts',
  'You search across multiple guidelines',
  'Unsure whether to titrate fast or slow',
  'Confused between Semaglutide, Tirzepatide or Liraglutide',
  'Side effects create uncertainty',
  'Follow-ups feel inconsistent',
]

export const afterItems = [
  'Clear protocol for every stage',
  'One unified, evidence-based system',
  'Step-by-step titration algorithm',
  'Clear selection criteria for each patient',
  'Immediate action protocols',
  'Standardized monitoring system',
]

export const painPoints = [
  {
    emoji: '😰',
    text: 'You have a patient in front of you and you’re not 100% sure if they are a candidate for GLP-1',
  },
  {
    emoji: '⏱️',
    text: 'You spend hours reviewing guidelines to find the right dose — information you should have in seconds',
  },
  {
    emoji: '🤷',
    text: 'When nausea or vomiting appears, you’re unsure whether to adjust, pause, or stop treatment',
  },
  {
    emoji: '💸',
    text: 'You prescribe GLP-1 but feel you’re not optimizing results due to lack of structured follow-up',
  },
  {
    emoji: '😓',
    text: 'Your patients struggle to maintain results because you don’t have a clear maintenance protocol',
  },
  {
    emoji: '😩',
    text: 'You feel other physicians are ahead of you in one of the fastest-growing areas in medicine',
  },
]

export const insideItems = [
  {
    emoji: '📘',
    title: '6 Complete Clinical Volumes',
    text: 'From patient selection (Volume 1) to long-term maintenance and rebound prevention (Volume 6)',
  },
  {
    emoji: '🔬',
    title: '300+ Clinical Protocols & Decision Algorithms',
    text: 'Including diagnostic criteria, titration pathways, and decision trees for real scenarios',
  },
  {
    emoji: '📊',
    title: 'Evaluation & Monitoring Checklists',
    text: '12 structured tools to ensure you never miss a critical step in consultation',
  },
  {
    emoji: '⚡',
    title: 'Immediate Action Algorithms',
    text: 'Ready-to-use clinical sheets for adverse events and complex situations',
  },
  {
    emoji: '📸',
    title: 'Pharmacological Comparison Tables',
    text: 'Clear comparisons between molecules, brands, and regional availability',
  },
  {
    emoji: '🎓',
    title: 'Real Clinical Cases (Bonus #4)',
    text: '50 real-world scenarios with full clinical reasoning and management',
  },
]

export const deliverables = [
  { emoji: '📘', text: 'The 6 Clinical Volumes covering the full GLP-1 treatment journey' },
  { emoji: '📝', text: 'Ready-to-use protocols and algorithms' },
  { emoji: '🏃', text: 'Clinical decision frameworks for every stage' },
  { emoji: '🗂️', text: 'Documentation tools, checklists, and patient tracking formats' },
]

export const bonuses = [
  {
    number: 1,
    title: 'GLP-1 Adverse Events Rescue Protocol™',
    body: 'What to do in the first minutes when nausea, vomiting, constipation, diarrhea, or intolerance appear. Includes step-by-step clinical algorithms, pharmacological management, when to reassure, when to adjust dosage, when to stop, and when to refer.',
    outcome: 'You will never hesitate again in front of a patient with side effects.',
    price: '$39',
    image: BONUS_1_IMAGE,
  },
  {
    number: 2,
    title: 'GLP-1 Switching & Titration Playbook™',
    body: 'The definitive algorithm to start, escalate, or switch medications without mistakes. Includes conversion between Semaglutide, Tirzepatide, and Liraglutide, titration schedules, what to do during drug shortages, and how to restart after interruptions.',
    outcome: 'You’ll know exactly how to move between treatments with confidence.',
    price: '$49',
    image: BONUS_2_IMAGE,
  },
  {
    number: 3,
    title: 'Medical-Legal Protection Kit™ for GLP-1 Prescribing',
    body: 'Professional informed consent templates, pre-treatment checklists, risk documentation, contraindications, and follow-up forms ready to use.',
    outcome: 'Reduce legal risk and document every clinical decision with confidence.',
    price: '$59',
    image: BONUS_3_IMAGE,
  },
  {
    number: 4,
    title: '50 Real GLP-1 Clinical Cases™',
    body: 'Diabetes, obesity, hypothyroidism, fatty liver, renal disease, elderly patients, poor responders, rebound weight gain, persistent nausea, insulin combinations, and more. Each case includes evaluation, clinical reasoning, management, and follow-up.',
    outcome: 'Gain years of clinical experience without waiting years.',
    price: '$79',
    image: BONUS_4_IMAGE,
  },
  {
    number: 5,
    title: 'Lean Mass Preservation Protocol™',
    body: 'Protein requirements, exercise guidelines, supplementation, and clinical strategies to prevent sarcopenia during GLP-1 treatment.',
    outcome: 'Your patients will lose fat — not muscle — and achieve better long-term outcomes.',
    price: '$49',
    image: BONUS_5_IMAGE,
  },
]

export const volumes = [
  {
    number: 1,
    title: 'Patient Selection & Clinical Foundation',
    hook: 'Stop guessing who qualifies. Start knowing with certainty.',
    text: 'Learn exactly how to identify the right patient, interpret labs correctly, and avoid the most common diagnostic mistakes before prescribing.',
  },
  {
    number: 2,
    title: 'The GLP-1 Prescribing Playbook',
    hook: 'Choose the right molecule for the right patient — every time.',
    text: 'Master the real differences between Semaglutide, Tirzepatide, and Liraglutide with clear selection criteria based on clinical profiles.',
  },
  {
    number: 3,
    title: 'Step-by-Step Titration Protocols',
    hook: 'Never hesitate on dosing again.',
    text: 'Follow a proven titration algorithm that tells you exactly when to start, when to increase, and how to adjust based on patient response.',
  },
  {
    number: 4,
    title: 'Adverse Events & Crisis Management',
    hook: 'Handle side effects with confidence, not fear.',
    text: 'Know exactly what to do when nausea, vomiting, or complications appear — including when to adjust, pause, or stop treatment.',
  },
  {
    number: 5,
    title: 'Special Populations & Optimization Strategies',
    hook: 'Treat complex patients without second-guessing yourself.',
    text: 'From diabetes and obesity to CKD and elderly patients — apply GLP-1 safely across real-world clinical scenarios.',
  },
  {
    number: 6,
    title: 'Long-Term Maintenance & Weight Rebound Prevention',
    hook: 'Keep results long after the prescription.',
    text: 'Learn how to prevent rebound weight gain, taper correctly, and transition patients into sustainable long-term outcomes.',
  },
]

export const testimonials = [
  {
    quote:
      'I used to feel nervous every time a patient asked for Ozempic. Now I have a clear protocol from the first consultation.',
    name: 'Maria C.',
    flag: '🇨🇴',
    role: 'Internal Medicine · Colombia',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/6e5959cf-a097-4175-bcbb-08c6f8358a89.jpg',
  },
  {
    quote:
      'The titration algorithms alone are worth it. I stopped jumping between multiple guidelines.',
    name: 'José R.',
    flag: '🇲🇽',
    role: 'Endocrinology · Mexico',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/617b5bef-65f8-47ac-b5d9-35abdf115b23.jpg',
  },
  {
    quote: 'The clinical cases gave me the confidence I was missing for complex patients.',
    name: 'Andrea S.',
    flag: '🇪🇸',
    role: 'Family Medicine · Spain',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/32b9e217-424b-4bf1-8eaa-24c430884a45.jpg',
  },
  {
    quote: 'As a general practitioner, this filled a huge gap. Everything in one place.',
    name: 'Luis M.',
    flag: '🇦🇷',
    role: 'General Practitioner · Argentina',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/faf366e0-0ca8-405c-96f8-4de2df790d2a.jpg',
  },
]

export const faqs = [
  {
    q: 'How do I receive the material?',
    a: 'Immediately after purchase, you’ll receive a download link via email. Access it anytime, from any device.',
  },
  {
    q: 'Is this applicable worldwide?',
    a: 'Yes. The content is based on international evidence (ADA, AACE, ESC) and adapted for physicians globally. Includes regional drug equivalents.',
  },
  {
    q: 'Are the files downloadable?',
    a: 'Yes. All materials are high-quality PDFs, ready for digital use or printing.',
  },
  {
    q: 'Is this a one-time payment?',
    a: 'Yes. No subscriptions. No recurring fees. Lifetime access.',
  },
  {
    q: 'Do I need to be a specialist?',
    a: 'No. Designed for both general practitioners and specialists. Clear, structured, and clinically practical.',
  },
]

export const purchaseNotifications = [
  { name: 'Dr. Valentina R.', city: 'Bogotá', flag: '🇨🇴' },
  { name: 'Dr. Santiago M.', city: 'Buenos Aires', flag: '🇦🇷' },
  { name: 'Dra. Camila P.', city: 'Ciudad de México', flag: '🇲🇽' },
  { name: 'Dr. Andrés L.', city: 'Lima', flag: '🇵🇪' },
  { name: 'Dra. Lucía F.', city: 'Madrid', flag: '🇪🇸' },
  { name: 'Dr. Mateo G.', city: 'Santiago', flag: '🇨🇱' },
  { name: 'Dra. Isabella T.', city: 'Quito', flag: '🇪🇨' },
  { name: 'Dr. Rodrigo V.', city: 'Montevideo', flag: '🇺🇾' },
  { name: 'Dra. Fernanda S.', city: 'San José', flag: '🇨🇷' },
  { name: 'Dr. Emilio C.', city: 'Miami', flag: '🇺🇸' },
  { name: 'Dra. Paula N.', city: 'Asunción', flag: '🇵🇾' },
  { name: 'Dr. Javier D.', city: 'Panamá', flag: '🇵🇦' },
]
